import { isRTL } from "@nextcloud/l10n";
const isRtl = isRTL();
export {
  isRtl as i
};
//# sourceMappingURL=rtl.mjs.map
